import {
  Box,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  Chip,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./HistoryDropdown.styles";

const HistoryDropdown = ({
  handleHistoryClick,
  historyAnchorEl,
  handleHistoryClose,
  history = [],
  handleHistorySelect,
}) => {
  // Status mapping for consistent styling
  const getStatusColor = (status) => {
    const statusMap = {
      completed: "success",
      failed: "error",
      cancelled: "default",
    };
    return statusMap[status] || "warning"; // limbo gets warning color
  };

  const getStatusIcon = (status) => {
    const iconMap = {
      completed: <CheckCircleIcon sx={{ fontSize: 16 }} />,
      failed: <ErrorOutlineIcon sx={{ fontSize: 16 }} />,
      cancelled: <CloseIcon sx={{ fontSize: 16 }} />,
    };
    return iconMap[status] || <QueryBuilderIcon sx={{ fontSize: 16 }} />; // limbo gets clock icon
  };

  const getDisplayStatus = (status) => {
    if (
      status === "completed" ||
      status === "failed" ||
      status === "cancelled"
    ) {
      return status;
    }
    return "limbo";
  };

  return (
    <Box>
      <IconButton color="inherit" onClick={handleHistoryClick}>
        <HistoryIcon />
      </IconButton>
      <Menu
        anchorEl={historyAnchorEl}
        open={Boolean(historyAnchorEl)}
        onClose={handleHistoryClose}
        slotProps={{
          paper: {
            sx: styles.menuPaper,
          },
        }}
      >
        {!history || history.length === 0 ? (
          <MenuItem disabled>No history available</MenuItem>
        ) : (
          history.map((job) => (
            <MenuItem
              key={job.job_id}
              onClick={() => handleHistorySelect(job.job_id)}
              sx={styles.menuItem}
            >
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mb: 0.5,
                  }}
                >
                  <Typography variant="body2" sx={styles.jobType}>
                    {`Job Type: ${job.job_type || "Unknown"}`}
                  </Typography>
                  {job.status && (
                    <Chip
                      icon={getStatusIcon(job.status)}
                      label={getDisplayStatus(job.status)}
                      color={getStatusColor(job.status)}
                      size="small"
                      sx={styles.statusChip}
                    />
                  )}
                </Box>
                <Typography variant="caption">
                  {job.job_id ? `ID: ${job.job_id}` : "Unnamed Project"}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <Typography variant="caption" color="text.secondary">
                    {job.created_at
                      ? new Date(job.created_at).toLocaleString()
                      : "No date"}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
          ))
        )}
      </Menu>
    </Box>
  );
};

export default HistoryDropdown;
